import { CheckForm, CheckQuiz, validators } from "@/components/site/CheckTools";
import { scrollToId } from "@/lib/site";

const FIELDS = [
  { key: "request_type", type: "select", placeholder: "Cosa ti serve?", options: ["Valutazione gratuita: quali 3 foto cambiare", "Preventivo per uno shooting (da 400 €)"], validate: validators.required("Scegli cosa ti serve: valutazione gratuita o preventivo.") },
  { key: "listing_url", type: "url", placeholder: "Link annuncio Booking o Airbnb", validate: validators.link },
  { key: "whatsapp", type: "tel", placeholder: "Numero WhatsApp, es. +39 347 1234567", validate: validators.phone },
];

export function PhotoCheckForm() {
  return (
    <CheckForm
      id="check-foto"
      testid="photo-check-form"
      kicker="Le tue foto, viste da Giovanni"
      fields={FIELDS}
      endpoint="/api/photo-checks"
      buttonLabel="Manda a Giovanni"
      consentText="e acconsento a essere ricontattato su WhatsApp per questa richiesta."
      promise={
        <>
          Entro 48 ore Giovanni guarda le foto del tuo annuncio e ti scrive su <span className="font-medium text-[#FAF7F2]">WhatsApp</span>: le 3 foto da cambiare, gratis, oppure il preventivo per lo shooting. Se le tue foto sono già giuste, te lo diciamo.
        </>
      }
      secondaryLink={{ to: "/aprire-struttura-ricettiva-sicilia", label: "Stai aprendo e non hai ancora foto? Parti da qui" }}
    />
  );
}

const DOMANDE = [
  "La prima foto del tuo annuncio è l'ambiente più bello, non l'ingresso o il bagno?",
  "Le foto sono scattate di giorno, con luce naturale e tende aperte?",
  "C'è almeno una foto per ogni ambiente, esterni e vista compresi?",
  "Le foto sono orizzontali e dritte, senza pareti storte?",
  "Le foto mostrano la casa com'è oggi (meno di 3 anni)?",
];

export function PhotoQuiz() {
  return (
    <CheckQuiz
      testid="photo-quiz"
      kicker="Gratis, per cominciare"
      title="Le tue foto vendono? 5 domande, 1 minuto."
      questions={DOMANDE}
      resultOk="Le basi ci sono. Vuoi il parere di Giovanni sulle 3 foto da cambiare? Mandagli il link."
      resultKo={(n) => (
        <>
          Ci sono <span className="text-[#E05A2C]">{n}</span> {n === 1 ? "punto che ti costa" : "punti che ti costano"} click. Manda le risposte a Giovanni: ti dice quali foto cambiare e in che ordine.
        </>
      )}
      waLabel="Manda le risposte a Giovanni"
      waMessage={(righe, stato) => `Ciao, ho fatto il test sulla pagina del fotografo. La mia struttura è ${stato}. Ecco le mie risposte: ${righe}. Vorrei parlarne con Giovanni.`}
      extraOk={{ label: "Fai valutare le foto", onClick: () => scrollToId("check-foto") }}
    />
  );
}
